import TextTitleCondensed from 'components/TextTitleCondensed.js'
import React from 'react'

export default function TextTitle (props) {
  return (
    <TextTitleCondensed
      fs='title'
      d='block'
      {...props}
    />
  )
}
